import { EnvironmentName } from '../types/environment-name';
import { ModuleID } from '../types/module-id';
import { CustomLogger } from '../types/custom-logger';

export class ErrorLogDto {
    public environmentName: EnvironmentName;
    public moduleID: ModuleID;
    public impact: number;
    public message: string;
    public request: string;
    public response: string;
    public exception: string;
    public isEmailNotification: boolean;
    public emailContacts: string[];
    public customLog: string;
    public customLogger: CustomLogger;
    public errorID: string;
}
